import { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { permissionsService } from "../services/api/permissionsService";
import { SIDEBAR_ROUTE_MAP } from "../configs/sidebarConfig";

const HomeRedirect = () => {
  const { token } = useContext(AuthContext);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (!token) return;

    const resolveHome = async () => {
      try {
        const res = await permissionsService.get_me_permission(token);

        const firstGroup = res?.groupPermissions?.find((g) => g.isSidebar);

        if (!firstGroup) {
          setTarget("/ho-tro"); // fallback an toàn
          return;
        }

        // Ưu tiên submenu nếu có
        const firstSub = firstGroup.permissions?.find((p) => p.isSidebar);

        if (firstSub) {
          setTarget(SIDEBAR_ROUTE_MAP[firstSub.nameSlug]);
        } else {
          setTarget(SIDEBAR_ROUTE_MAP[firstGroup.groupSlug] || "/ho-tro");
        }
      } catch (err) {
        console.error("Resolve home failed:", err);
        setTarget("/ho-tro");
      }
    };

    resolveHome();
  }, [token]);

  if (!target) return null;

  return <Navigate to={target} replace />;
};

export default HomeRedirect;
